exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ke-th[data-v-0961ce26]{margin-bottom:20px;font-size:18px;color:#0256ff}", ""]);

// exports
